export default __webpack_public_path__ + "static/media/retailer.44662982.jpeg";